"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgChecklistFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M2 4a2 2 0 012-2h16a2 2 0 012 2v16a2 2 0 01-2 2H4a2 2 0 01-2-2V4zm8.53 9.22a.75.75 0 010 1.06l-2.396 2.397a.757.757 0 01-1.07 0L5.72 15.333a.75.75 0 011.06-1.06l.819.818 1.87-1.871a.75.75 0 011.061 0zm2.22 1.03a.75.75 0 000 1.5h5a.75.75 0 000-1.5h-5zm-2.22-6.78a.75.75 0 010 1.06l-2.396 2.397a.757.757 0 01-1.07 0L5.72 9.583a.75.75 0 011.06-1.06l.819.818 1.87-1.871a.75.75 0 011.061 0zm2.22 1.03a.75.75 0 000 1.5h5a.75.75 0 000-1.5h-5z' }))); };
exports.default = SvgChecklistFilled;
//# sourceMappingURL=ChecklistFilled.js.map